import React from "react";

import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";
  
  function withRouter(Component) {
    function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();

      Component.location = location;
      Component.navigate = navigate;
      Component.params = params;

      return (
        <Component
          {...props}
          location = {location}
          navigate = {navigate}
          params = {params}
        />
      );
    }
  
    return ComponentWithRouterProp;
  }

  export default withRouter;

